import React, { useState, useEffect } from 'react';
import XSearchSection from './XSearchSection';
import XSavedSearches from './XSavedSearches';
import { useAuth } from '../components/AuthContext';
import supabase from '../components/supabaseClient';
import './XTool.css';

const XSearchTool = () => {
    const { userId, isMobile } = useAuth();
    const [showSavedSearches, setShowSavedSearches] = useState(false);
    const [currentSearch, setCurrentSearch] = useState(null);
    const [savedSearches, setSavedSearches] = useState([]);
    const [loadingSavedSearches, setLoadingSavedSearches] = useState(false);

    console.log("XSearchTool rendered, userId:", userId, "showSavedSearches:", showSavedSearches);
    
    // Debug user ID
    useEffect(() => {
        console.log("User auth state changed:", 
            userId ? "User is logged in with ID: " + userId : "User is not logged in");
    }, [userId]);

    // Add effect to log when saved searches view changes
    useEffect(() => {
        console.log("Saved searches view changed to:", showSavedSearches);
    }, [showSavedSearches]);
    
    // Preload saved searches when component mounts
    useEffect(() => {
        if (userId) {
            fetchSavedSearches();
        }
    }, [userId]);
    
    // Fetch saved searches from Supabase
    const fetchSavedSearches = async () => {
        if (!userId) return;
        
        setLoadingSavedSearches(true);
        console.log("Preloading saved searches for user:", userId);
        
        try {
            const { data, error } = await supabase
                .from('saved_searches')
                .select('*')
                .eq('user_id', userId)
                .eq('type', 'twitter')
                .order('created_at', { ascending: false });
                
            if (error) {
                console.error('Error fetching saved searches:', error);
                throw error;
            }
            
            if (data) {
                console.log(`Found ${data.length} saved searches to preload`);
                setSavedSearches(data);
            }
        } catch (error) {
            console.error('Error preloading saved searches:', error);
        } finally {
            setLoadingSavedSearches(false);
        }
    };

    return (
        <div className="xtool-tool-container">
            <div className="xtool-tool-content">
                {showSavedSearches && userId ? (
                    <XSavedSearches 
                        onSelectSearch={(search) => {
                            console.log("Selected search:", search);
                            setCurrentSearch(search);
                            setShowSavedSearches(false);
                        }}
                        onNewSearch={() => {
                            console.log("New search button clicked");
                            setCurrentSearch(null);
                            setShowSavedSearches(false);
                        }}
                        preloadedSearches={savedSearches}
                        isLoading={loadingSavedSearches}
                    />
                ) : (
                    <XSearchSection 
                        savedSearch={currentSearch}
                        onViewSavedSearches={() => {
                            console.log("View saved searches clicked");
                            setShowSavedSearches(true);
                        }}
                        isMobile={isMobile}
                        isLoggedIn={!!userId}
                        onSaveSearch={() => fetchSavedSearches()} // Refresh saved searches when a new one is saved
                    />
                )}
            </div>
        </div>
    );
};

export default XSearchTool; 